import React from "react";
import ResizeObserver from 'resize-observer-polyfill';
/* NOTE: ResizeSensor会导致react-dnd拖放缩略图异常
//const ResizeSensor = require('css-element-queries/src/ResizeSensor');
*/

// NOTE: 解决css transform导致元素周围出现空白的问题
// https://blog.csdn.net/m0_66345324/article/details/122579078
class ScaleContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: undefined,
            height: undefined,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.width !== this.props.width ||
            prevProps.height !== this.props.height)
        {
            this.setState({width: undefined, height: undefined});
        }
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        if (this._updateViewSizeTimer) {
            clearTimeout(this._updateViewSizeTimer);
            this._updateViewSizeTimer = null;
        }

        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            delete this._resizeObserver;
        }

        if (this._resizeSensor) {
            this._resizeSensor.detach();
            delete this._resizeSensor;
        }
    }

    _updateViewSize = () => {
        if (this._updateViewSizeTimer) {
            clearTimeout(this._updateViewSizeTimer);
            this._updateViewSizeTimer = null;
        }

        if (this._ref) {
            const width = this._ref.clientWidth;
            const height = this._ref.clientHeight;
            this.setState({width: width, height: height * this.props.scale});
        }
    };

    _updateViewSizeLater = () => {
        if (this._updateViewSizeTimer) {
            return;
        }
        this._updateViewSizeTimer = setTimeout(this._updateViewSize, 100);
    };

    _setupRef = (r) => {
        if (!r) {
            return;
        }

        if (this._ref === r) {
            return;
        }

        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            delete this._resizeObserver;
        }

        if (this._resizeSensor) {
            this._resizeSensor.detach();
            delete this._resizeSensor;
        }

        this._ref = r;
        /* NOTE: ResizeSensor会导致react-dnd拖放缩略图异常
        //this._resizeSensor = new ResizeSensor(this._ref, this._updateViewSizeLater);
        */
        this._resizeObserver = new ResizeObserver(this._updateViewSizeLater);
        this._resizeObserver.observe(this._ref);

        this._updateViewSizeLater();
    };

    render() {
        const { children, ...props } = this.props;
        return (
            <div style={{width: this.state.width, height: this.state.height}}>
                <div ref={this._setupRef} {...props}>
                    {children}
                </div>
            </div>
        );
    }
}

export default ScaleContainer;
